// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1AuWc","filesListContainer":"PosDisputesFiles_filesListContainer__3kBWc","filesButton":"PosDisputesFiles_filesButton__3L5zt"};